module.exports = __webpack_public_path__ + "static/canva-745e615a1ea0d2c9979bd832ff583259.svg";